<template>
  <div class="profile-page">
    <section class="section-profile-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-default shape-skew alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </section>
    <section class="section section-skew">
      <div class="container">
        <card shadow class="card-profile mt--300" no-body>
          <div class="px-4">
            <div class="row justify-content-center pb-5">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <a href="#">
                    <img v-lazy="'img/logo/cas.jpeg'" class="rounded-circle" />
                  </a>
                </div>
              </div>
            </div>
            <div class="text-center pt-5 mt-5">
              <h3>
                Cikarang Ambulans Service
                <!-- <span class="font-weight-light">, 27</span> -->
              </h3>
              <div class="h6 font-weight-300">
                <i class="ni location_pin mr-2"></i>Cikarang, Jawa Barat
              </div>
              <!-- <div class="h6 mt-4">
                <i class="ni business_briefcase-24 mr-2"></i>Solution Manager -
                Creative Tim Officer
              </div>
              <div>
                <i class="ni education_hat mr-2"></i>University of Computer
                Science
              </div> -->
            </div>
            <div class="mt-5 py-5 border-top text-center">
              <div class="row justify-content-center">
                <div class="col-lg-9">
                  <p>
                    Cikarang Ambulans Service bergerak di bidang
                    transportasi/akomodasi ambulance untuk membantu umat, baik
                    pasien atau jenazah. Cikarang Ambulans Service telah
                    bersinergi dengan beberapa rumah sakit di Kabupaten Bekasi,
                    Kota Bekasi, Kota Karawang, dan Kabupaten Karawang. <br />
                    <br />
                    CAS juga bersinergi dengan Yayasan Yatim Piatu dan Duafa,
                    serta berbagai organisasi kemasyarakatan di wilayah
                    Kabupaten Karawang, Kota Karawang, Kabupaten Bekasi, dan
                    Kota Bekasi. Sebagian pendapatan yang telah kami terima,
                    kami gunakan untuk biaya operasional yayasan dan untuk
                    pasien dhuafa yang membutuhkan. <br />
                    <br />
                    CAS melayani pengantaran dan penjemputan pasien/jenazah
                    antar kota, antar propinsi, antar pulau, dan antar negara.
                    Kami juga melayani pemulasaraan non muslim dan muslim serta
                    perlengkapan penunjang lainnya. <br />
                    <br />
                    Unit yang tersedia di Yayasan Cikarang Ambulans Service
                    adalah Ambulance Non Medis, Ambulance Medis, Ambulans
                    Jenazah, Ambulance Mini ICU, dan Ambulance VIP. Dengan crew
                    yang telah mendapatkan pelatihan sebagai "Driver Ambulance"
                    dan telah mendapatkan pelatihan BHD (Bantuan Hidup
                    Dasar)/BLS (Basic Life Support) dengan dibuktikan adanya
                    "Sertifikat Pelatihan".
                  </p>
                  <!-- <a href="#">Show more</a> -->
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>
  </div>
</template>
<script>
export default {};
</script>
<style></style>
